<template>
  <div class="addmodal fixed w-full h-screen z-20 top-0 left-0 flex justify-center items-start overflow-auto">
    <div class="bg-white m-auto w-9/12 md:w-7/12 h-auto flex flex-col rounded-md justify-center items-center">
      <h2
        class="font-costea w-11/12 px-2 py-1 my-4 mx-auto border-b border-gray-200 text-left text-t20 font-medium text-costeaBlack">
        Crear componente
      </h2>
      <div class="bg-gray-200 w-11/12 h-24 rounded-md relative mb-4"
        :style="`background-repeat: no-repeat; background-size: contain; background-position:center center; ${showImage}`">
        <span @click="$refs.myFiles.click()"
          class="cursor-pointer flex flex-row items-center justify-center absolute bg-costeaPrimary text-white w-10 h-10 right-4 bottom-4 rounded-full">
          <i class="ri-camera-fill text-lg"></i>
          <input type="file" @input="pickFile" @change="onSelectedImage" ref="myFiles" style="display:none" />
        </span>
      </div>
      <p v-if="errorSizeImage"
        class="text-costeaSalmon font-costea text-t12 text-left w-11/12 bg-costeaSalmonDisabled px-2 py-1 rounded-md ">
        {{ this.errorSizeImage }}</p>

      <form @submit.prevent="validateForm" class="flex flex-col justify-start items-center w-11/12">

        <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <p for="nombre" class="w-full text-costeaGray items-center content-center text-t14 mb-3">Nombre: *</p>
            <input id="nombre" type="text" v-model="nombre" required
              class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-3 text-t14 w-full rounded-md tracking-wide"
              placeholder="Nombre del componente">
          </div>
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <p for="referencia" class="w-full text-costeaGray items-center content-center text-t14 mb-3">Referencia: *
            </p>
            <input id="referencia" type="text" v-model="referencia" required
              class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-3 text-t14 w-full rounded-md tracking-wide"
              placeholder="Referencia del componente">
          </div>
        </div>

        <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <p for="codigoBarras" class="w-full text-costeaGray items-center content-center text-t14 mb-3">Código de
              barras: </p>
            <input id="codigoBarras" type="text" v-model="codigoBarras"
              class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-3 text-t14 w-full rounded-md tracking-wide"
              placeholder="Código de barras">
          </div>
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <p for="unidadMedida" class="w-full text-costeaGray items-center content-center text-t14 mb-3">Unidad de
              medida: *</p>
            <select id="unidadMedida" v-model="unidadMedida" required
              class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-3 text-t14 w-full rounded-md tracking-wide">
              <option value="" selected disabled>Seleccione una unidad (kg,cm,lb...)</option>
              <option value="kg">Kilogramos (kg)</option>
              <option value="cm">Centímetros (cm)</option>
              <option value="m">Metros (m)</option>
              <option value="u">Unidad (u)</option>
              <option value="L">Litros (l)</option>
              <option value="ml">Mililitros (ml)</option>
              <option value="cm3">Centímetros (cm3)</option>
              <option value="gr">Gramos (gr)</option>
              <option value="lb">Libras (Lb)</option>
              <option value="km">Kilometro (km)</option>
              <option value="t">Toneladas (ton)</option>
            </select>
          </div>
        </div>

        <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <p class="w-full text-costeaGray items-center content-center text-t14 mb-3">Tipo de materia prima *</p>
            <div class="flex justify-start items-center w-10/12">
              <input type="radio" id="mpNacional" v-model="materiaPrima" value="Nacional"
                class="h-3 justify-start items-center outline-none" @click="cop = true, usd = false, costoUSD = ''">
              <label for="mpNacional"
                class="relative text-costeaBlack text-t14 tracking-wide mr-2 leading-6 cursor-pointer">Nacional</label>
              <input type="radio" id="mpImportada" v-model="materiaPrima" value="Importada"
                class="h-3 justify-start items-center outline-none" @click="cop = false, usd = true, costoCop = ''">
              <label for="mpImportada"
                class="relative text-costeaBlack text-t14 tracking-wide ml-2 leading-6 cursor-pointer">Importada</label>
            </div>
          </div>

          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <div v-if="cop" class="w-full">
              <p class="w-full text-costeaGray items-center content-center text-t14 mb-3">Costo en COP *</p>
              <input id="costoCOP" type="number" min="0" max="999999999" step="0.01" v-model="costoCOP" required
                class=" bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-3 text-t14 w-full rounded-md tracking-wide"
                placeholder="$ --">
            </div>
            <div v-if="usd" class="flex w-full flex-row justify-around flex-wrap">
              <div class="lg:w-5/12 w-full flex flex-col">
                <p class="text-costeaGray items-center content-center text-t14 mb-3">Costo en USD *</p>
                <input id="costoUSD" type="number" min="0" max="999999" step="0.01" v-model="costoUSD" required
                  class=" bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea p-2 text-t14 w-full rounded-md tracking-wide"
                  placeholder="$ --">
              </div>
              <div class="lg:w-5/12 w-full flex flex-col">
                <p class="text-costeaGray items-center content-center text-t14 mb-3">Tasa de cambio *</p>
                <input id="tasaCambio" type="number" min="0" max="999999" step="0.01" v-model="tasaCambio" required
                  class=" bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea p-2 text-t14 w-full rounded-md tracking-wide"
                  placeholder="$ --">
              </div>
              <div class="w-full flex justify-end flex-row mt-4">
                <p class="text-right text-costeaGray items-center content-center text-t14 mb-3">COP $
                  <span>{{ interNumberFormat((costoUSD * tasaCambio).toFixed(2)) }}</span></p>
              </div>
            </div>
          </div>

        </div>
        <div class="mb-4 p-2 flex content-end items-end w-full rounded-md justify-end">
          <button
            class="bg-costeaBtn2 rounded-md text-costeaPrimary hover:bg-costeaBtn2Hover duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide mr-4"
            @click="toggleModal()" type="button">Cancelar</button>
          <div v-show="this.buttonText == 'Creando...'"
            class="bg-costeaPrimary rounded-md text-white duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide mr-4">
            Creando...</div>
          <button :disabled="this.disabledButton" v-show="this.buttonText == 'Crear' || this.buttonText == '¡Listo!'"
            :class="'rounded-md text-white hover:bg-costeaHover duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide ml-4 ' + buttonBg"
            type="submit">{{ buttonText }}</button>
        </div>
      </form>

    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      cop: false,
      usd: false,
      buttonText: 'Crear',
      buttonBg: 'bg-costeaPrimary',
      disabledButton: false,

      nombre: '',
      referencia: '',
      unidadMedida: '',
      materiaPrima: null,
      costoUSD: 0,
      tasaCambio: 0,
      cantidad: 1,
      costoTotal: 0,
      codigoBarras: '',
      picture: null,
      previewImage: null,

      errorSizeImage: '',
    }
  },
  computed: {
    ...mapState(['costea']),
    showImage() {
      if (this.previewImage != null) {
        return `background-image:url('${this.previewImage}');`
      } else {
        return 'background-color: #f1f2f3;'
      }
    },
  },
  methods: {
    interNumberFormat(number) {
      let interNF = new Intl.NumberFormat('es-CO');
      let numberDecimals = parseFloat(number)
      numberDecimals = numberDecimals.toFixed(2)
      return interNF.format(numberDecimals)
    },
    onSelectedImage(event) {
      this.picture = event.target.files[0]
    },
    pickFile() {
      let input = this.$refs.myFiles
      let file = input.files
      if (file && file[0]) {
        let reader = new FileReader
        reader.onload = e => {
          this.previewImage = e.target.result
        }
        reader.readAsDataURL(file[0])
      }
    },
    validateForm() {
      this.buttonText = 'Creando...'
      this.setComponent()
    },

    setComponent: function () {
      this.errorSizeImage = ''
      if (this.picture && this.picture.size > 450000) {
        this.errorSizeImage = 'El tamaño de la imagen no puede ser mayor a 450kb'

        this.buttonText = 'Crear'
        this.disabledButton = false
        this.buttonBg = 'bg-costeaPrimary'
        return
      }
      let config = {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token'),
          'Content-Type': 'multipart/form-data'
        }
      }
      let formData = new FormData()
      if (this.picture != null) {
        formData.append('picture', this.picture);
      }
      formData.append('name', this.nombre);
      formData.append('referencia', this.referencia)
      formData.append('unidad_de_medida', this.unidadMedida)
      formData.append('tipo_materia_prima', this.materiaPrima)
      formData.append('costo_unitario', this.costoUSD == '' ? parseFloat(this.costoCOP) : parseFloat(this.costoUSD))
      formData.append('tasa_de_cambio', this.tasaCambio)
      formData.append('cantidad', this.cantidad)
      formData.append('costo_total', this.costoTotal)
      axios
        .post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}componente-add`,
          formData, config)
        .then(() => {
          setTimeout(() => {
            this.buttonText = 'Listo!'
            this.disabledButton = true
            this.buttonBg = 'bg-costeaDarkGreen'
          }, 100)
          setTimeout(() => {
            this.toggleModal()
          }, 1000)
          setTimeout(() => {
            this.buttonText = 'Crear'
            this.disabledButton = false
            this.buttonBg = 'bg-costeaPrimary'
            this.nombre = ''
            this.referencia = ''
            this.codigoBarras = ''
            this.unidadMedida = ''
            this.materiaPrima = ''
            this.costoCOP = ''
            this.costoUSD = ''
            this.tasaCambio = ''
            this.previewImage = null
          }, 3000)
        }
        ).catch(
          (error) => {
            console.log(error)
          }
        );
    },
    modalActive() {
      this.modalAct = true
      this.modalAct == true ? this.modalAct = false : this.modalAct = true
      return this.modalAct
    },
    toggleModal() {
      this.$emit('closeModalAdd', this.modalActive())
      this.$emit('reloadData', true)
    },
    onProcess() {
      this.buttonText = 'Creando...'
    }
  }
}
</script>

<style scoped>
.addmodal {
  background: rgba(0, 0, 0, 0.6);
}
</style>